module.exports = __webpack_public_path__ + "img/gongye.d333e702.png";